import React from 'react';

// Utils //
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';

// Styles //
import "./DocumentCard.scss";

interface DocumentCardProps {
    title: string;
    description: any;
    image: string;
    buttonLabel: string;
    documentLink?: any;
    videoLink?: string;
    tipo: any;
    onShowModal?: (value: string) => void;
}

const DocumentCard = (props: DocumentCardProps) => {
    const {title, description, image, buttonLabel, documentLink, videoLink, onShowModal} = props;
    return (
        <div className={`m-document-card`}>
            <div className="m-document-card__image">
                <img src={image} alt={title} />
            </div>
            <div className="m-document-card__description">
                <h3>{title}</h3>
                {contentfulRenderOptions(description.json)}
                <div className="m-document-card__description__button">
                    {videoLink ? (
                        buttonLabel && <span onClick={() => onShowModal?.(videoLink)}>{buttonLabel}</span>
                    ) : (
                        buttonLabel && <a href={documentLink && documentLink[0].file.url} download target="_blank" rel="noreferrer">{buttonLabel}</a>  
                    )}
                </div>
            </div>
        </div>
    )
}

export default DocumentCard